import { render, staticRenderFns } from "./imgView.vue?vue&type=template&id=5d8a9f89&scoped=true&"
import script from "./imgView.vue?vue&type=script&lang=js&"
export * from "./imgView.vue?vue&type=script&lang=js&"
import style0 from "./imgView.vue?vue&type=style&index=0&id=5d8a9f89&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8a9f89",
  null
  
)

export default component.exports